var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11104_7747",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11104_7747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37479 16.25C4.19757 16.25 4.04917 16.1901 3.92958 16.0702C3.80986 15.9505 3.75 15.8021 3.75 15.625V4.375C3.75 4.19792 3.80993 4.04951 3.92979 3.92979C4.04965 3.80993 4.19812 3.75 4.37521 3.75C4.55243 3.75 4.70083 3.80993 4.82042 3.92979C4.94014 4.04951 5 4.19792 5 4.375V15.625C5 15.8021 4.94007 15.9505 4.82021 16.0702C4.70035 16.1901 4.55188 16.25 4.37479 16.25ZM9.99979 16.25C9.82257 16.25 9.67417 16.1901 9.55458 16.0702C9.43486 15.9505 9.375 15.8021 9.375 15.625V13.9262C9.375 13.7492 9.43493 13.6008 9.55479 13.481C9.67465 13.3612 9.82313 13.3012 10.0002 13.3012C10.1774 13.3012 10.3258 13.3612 10.4454 13.481C10.5651 13.6008 10.625 13.7492 10.625 13.9262V15.625C10.625 15.8021 10.5651 15.9505 10.4452 16.0702C10.3253 16.1901 10.1769 16.25 9.99979 16.25ZM15.6248 16.25C15.4476 16.25 15.2992 16.1901 15.1796 16.0702C15.0599 15.9505 15 15.8021 15 15.625V4.375C15 4.19792 15.0599 4.04951 15.1798 3.92979C15.2997 3.80993 15.4481 3.75 15.6252 3.75C15.8024 3.75 15.9508 3.80993 16.0704 3.92979C16.1901 4.04951 16.25 4.19792 16.25 4.375V15.625C16.25 15.8021 16.1901 15.9505 16.0702 16.0702C15.9503 16.1901 15.8019 16.25 15.6248 16.25ZM9.99979 11.4744C9.82257 11.4744 9.67417 11.4144 9.55458 11.2946C9.43486 11.1749 9.375 11.0265 9.375 10.8494V9.15062C9.375 8.97354 9.43493 8.82514 9.55479 8.70542C9.67465 8.58556 9.82313 8.52562 10.0002 8.52562C10.1774 8.52562 10.3258 8.58556 10.4454 8.70542C10.5651 8.82514 10.625 8.97354 10.625 9.15062V10.8494C10.625 11.0265 10.5651 11.1749 10.4452 11.2946C10.3253 11.4144 10.1769 11.4744 9.99979 11.4744ZM9.99979 6.69875C9.82257 6.69875 9.67417 6.63882 9.55458 6.51896C9.43486 6.39924 9.375 6.25083 9.375 6.07375V4.375C9.375 4.19792 9.43493 4.04951 9.55479 3.92979C9.67465 3.80993 9.82313 3.75 10.0002 3.75C10.1774 3.75 10.3258 3.80993 10.4454 3.92979C10.5651 4.04951 10.625 4.19792 10.625 4.375V6.07375C10.625 6.25083 10.5651 6.39924 10.4452 6.51896C10.3253 6.63882 10.1769 6.69875 9.99979 6.69875Z",
    fill: "#475467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.3265e640b3f723cab538d70957f4f6df.svg";
export { ForwardRef as ReactComponent };